import { render, staticRenderFns } from "./refresh_scopes.vue?vue&type=template&id=511a235f"
import script from "./refresh_scopes.vue?vue&type=script&lang=js"
export * from "./refresh_scopes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports